<template>
  <div>
    <h4>Cambios en el contrato</h4>
    <p>Te informamos de algunas modificaciones a nuestro
      Contrato de Comisión Mercantil que entrarán en vigor
      a partir del <b>10 de agosto del 2020</b>.</p>
    <p>Los cambios más importantes son los siguientes:</p>
    <ol>
      <li>Actualizamos el formato de carátula al formato válido
        ante Autoridades.</li>
      <li>Incluimos obligaciones por parte de Cumplo con relación
        a la administración y cobranza.</li>
      <li>Realizamos correcciones de forma en el cuerpo del Contrato.</li>
      <li>Ajustamos la Comisión Mercantil al 0.2% del capital pagado
        + I.V.A. mensual.</li>
    </ol>
    <p>Recuerda que, si tienes dudas con cualquiera de estos cambios,
      por favor ponte en contacto con nosotros a través del correo
      <a href="mailto:contacto.mx@cumplo.com">contacto.mx@cumplo.com</a>,
      y te brindaremos más información.</p>
    <p>En caso de que no aceptes firmar la actualización del contrato,
      envía un correo a la dirección <a href="mailto:contacto.mx@cumplo.com">
        contacto.mx@cumplo.com</a> con asunto <i>"Declinación de contrato"</i>
      y especifica el motivo antes del 31 de julio del 2020. Ten en cuenta que
      a partir de que el nuevo contrato entre en vigor, no podrás seguir
      invirtiendo en Cumplo.</p>
    <p>Cabe aclarar que las modificaciones mencionadas,no tienen efecto alguno
      en las oportunidades en las que hayas participado antes del 10
      de agosto del 2020.</p>
    <a href="/static/pdf/C.M.P.F-2020.pdf" target="_blank" >
      Ver ejemplo del contrato para persona física.
    </a><br>
    <a href="/static/pdf/C.M.P.M-2020.pdf" target="_blank">
      Ver ejemplo del contrato para persona  moral.
    </a>
  </div>
</template>
<script>
export default {
  name: 'UserProfileChangesContract'
}
</script>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileChangesContract.vue